var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('img',{staticClass:"empty-image",attrs:{"src":require("../assets/img/down.png"),"alt":"服务已到期"}}),_c('div',{staticClass:"message-primary"},[_vm._v("抱歉，服务已到期")]),_c('div',{staticClass:"message-secondary"},[_vm._v("您查看的内容已下架啦~")])])
}]

export { render, staticRenderFns }